import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Heart, MessageCircle } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PostDetailPage = () => {
  const { postId } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPost();
  }, [postId]);

  const fetchPost = async () => {
    try {
      const response = await axios.get(`${API}/feed/posts/${postId}`);
      setPost(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  if (!post) return <div className="min-h-screen flex items-center justify-center">Post not found</div>;

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <Button variant="ghost" onClick={() => navigate('/')} className="mb-4">← Back</Button>
        <Card>
          <CardContent className="p-6">
            <div className="flex items-start gap-3 mb-4">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-purple-500 flex items-center justify-center text-white font-bold">
                {post.author?.avatar_url ? <img src={post.author.avatar_url} className="w-full h-full rounded-full object-cover" alt={post.author?.full_name} /> : post.author?.full_name?.[0] || 'U'}
              </div>
              <div className="flex-1">
                <button onClick={() => navigate(`/users/${post.author?.id || post.author_user_id}`)} className="font-bold text-lg hover:underline">
                  {post.author?.full_name || 'User'}
                </button>
                <div className="flex items-center gap-2">
                  <Badge>{post.post_type}</Badge>
                  <span className="text-sm text-muted-foreground">{new Date(post.created_at).toLocaleString()}</span>
                </div>
              </div>
            </div>
            
            <p className="text-lg mb-4 whitespace-pre-wrap">{post.text}</p>
            
            {post.media_images && post.media_images.length > 0 && (
              <div className="grid grid-cols-2 gap-2 mb-4">
                {post.media_images.map((img, idx) => (
                  <img key={idx} src={img} className="w-full object-cover rounded" alt="" />
                ))}
              </div>
            )}
            
            <div className="flex items-center gap-6 pt-4 border-t">
              <div className="flex items-center gap-1">
                <Heart className={post.viewer_has_liked ? 'fill-red-500 text-red-500' : 'text-muted-foreground'} />
                <span>{post.like_count || 0} likes</span>
              </div>
              <div className="flex items-center gap-1">
                <MessageCircle className="text-muted-foreground" />
                <span>{post.comment_count || 0} comments</span>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PostDetailPage;
